import * as yup from "yup";
const message = "Please choose at least one role";
export const schema = yup
  .object()
  .shape({
    roles: yup.array().of(yup.string().required(message)).min(1, message).required(message),
  })
  .required(message);
